import { readProductDetailsByChunks } from "../ProductBundle/getBundleItemsDetail";

export function* getImportedItemsDetail(productIds) {
    // Remove duplicate IDs, and dont add in null/undefined values
    let uniqueProductIds = new Set();

    productIds.forEach(value => {
        if (value !== null && value !== undefined)
            uniqueProductIds.add(value);
    });

    uniqueProductIds = [...uniqueProductIds];

    // Read each chunk of 50 ids sequentially and compile into productDetailList
    const productDetailList = yield readProductDetailsByChunks(uniqueProductIds, 'PURCHASE');

    return productDetailList;
}
